module.exports = __webpack_public_path__ + "static/media/podessys.61979324.png";